import { request } from '../api';
import { useReferralStore } from '../stores';
import { storeDidCatch } from '../utils';

export const getReferralConfig = async () => {
  try {
    const { setReferralConfig } = useReferralStore.getState();

    const { data: { data = {} } = {} } = await request.get('/referral/link');

    setReferralConfig(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getReferralConfig]', error);
  }
};

export const getReferralStats = async () => {
  try {
    const { setReferralStats } = useReferralStore.getState();

    const { data: { data = {} } = {} } = await request.get('/referral/stats');

    setReferralStats(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getReferralStats]', error);
  }
};
